"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closePaddingShorthand = exports.openPaddingShorthand = void 0;
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var css_data_types_1 = require("../../css-data-types");
// padding
var openPaddingShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpenerFromPart)({
        prop: 'padding',
        dataType: css_data_types_1.ALWAYS_DATA_TYPE,
        partOpener: (0, shorthand_parser_utils_1.edgesShorthandOpener)('padding'),
        openedProps: ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
    });
};
exports.openPaddingShorthand = openPaddingShorthand;
var closePaddingShorthand = function () {
    return (0, shorthand_parser_utils_1.edgesShorthandCloser)('padding');
};
exports.closePaddingShorthand = closePaddingShorthand;
//# sourceMappingURL=padding-shorthand.js.map